export const PAN_ZOOM = 'PANZOOM';
export const panZoom = data => {
  return {
    type: PAN_ZOOM,
    data
  };
};

export const SET_MAP_UPDATE_SOURCE = 'SET_MAP_UPDATE_SOURCE';
export const setMapUpdateSource = data => {
  return {
    type: SET_MAP_UPDATE_SOURCE,
    data
  };
};